import { render, staticRenderFns } from "./painel-rating.vue?vue&type=template&id=4de028d8&"
import script from "./painel-rating.vue?vue&type=script&lang=js&"
export * from "./painel-rating.vue?vue&type=script&lang=js&"
import style0 from "./painel-rating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports